// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// // import { RiUserAddLine } from "react-icons/ri";
// import { GoSearch } from "react-icons/go";
// import { BsInfoLg } from "react-icons/bs";
// import WebHeader from "../WebHeader/WebHeader";
// import Sidebar from "../Sidebar/Sidebar";
// import WebFooter from "../WebFooter/WebFooter";
// import { MdKeyboardArrowRight } from "react-icons/md";
// import { MdKeyboardArrowLeft } from "react-icons/md";
// import { API_URL } from "../../Config";

// const CareerApplications = () => {
//   const navigate = useNavigate();

//   //   Sample data for reservations
//   const reservationsData = [
//     {
//       full_name: "Xyz",
//       email: "john@example.com",
//       contact_number: 9876543210,
//       gender: "Female",
//       hospitality_experience: "Yes",
//       available_from: "2025-03-23",
//     },
//     {
//       full_name: "Abc",
//       email: "john@example.com",
//       contact_number: 9876543211,
//       gender: "Male",
//       hospitality_experience: "No",
//       available_from: "2025-04-23",
//     },
//   ];

//   // State for managing search, pagination, and reservations
//   const [searchQuery, setSearchQuery] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage] = useState(6);

//   // Filtering reservations based on search query
//   const filteredCompany = reservationsData.filter(
//     (row) =>
//       row.full_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       row.email.toLowerCase().includes(searchQuery.toLowerCase())
//     //   ||
//     //   row.contact_number.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   // Get current rows for pagination
//   const indexOfLastRow = currentPage * rowsPerPage;
//   const indexOfFirstRow = indexOfLastRow - rowsPerPage;
//   const currentRows = filteredCompany.slice(indexOfFirstRow, indexOfLastRow);

//   // Change page
//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   const Pagination = ({ rowsPerPage, totalRows, paginate, currentPage }) => {
//     const totalPages = Math.ceil(totalRows / rowsPerPage);

//     return (
//       <nav className="flex justify-end my-[2%]">
//         <ul className="flex items-center">
//           {currentPage > 1 && (
//             <li className="mx-1">
//               <button
//                 onClick={() => paginate(currentPage - 1)}
//                 className="p-1 bg-gray-200 text-xs rounded-full"
//               >
//                 <MdKeyboardArrowLeft />
//               </button>
//             </li>
//           )}
//           <li className="mx-1">
//             <span className="px-2 py-2 text-xs">
//               {currentPage} / {totalPages}
//             </span>
//           </li>
//           {currentPage < totalPages && (
//             <li className="mx-1">
//               <button
//                 onClick={() => paginate(currentPage + 1)}
//                 className="p-1 bg-gray-200 text-xs rounded-full"
//               >
//                 <MdKeyboardArrowRight />
//               </button>
//             </li>
//           )}
//         </ul>
//       </nav>
//     );
//   };

//   // Table column titles
//   const tableTitles = [
//     "Name",
//     "Email",
//     "Contact No.",
//     "Gender",
//     "Hotel Industry Experience",
//     "Available From",
//     "Actions",
//   ];

//   // Function to handle booking edit
//   const handleEditCareerApplication = (row) => {
//     navigate("/EditCareerApplication", { state: { applicationDetails: row } });
//   };

//   return (
//     <div className="bg-[#F8F6F6] text-[14px] md:text-xl lg:text-[16px] 2xl:text-2xl leading-6 md:leading-8 lg:leading-7 2xl:leading-10">
//       <WebHeader />

//       <div className="hidden lg:block">
//         <Sidebar />
//       </div>
//       <br />

//       <div className="mt-[70px] mx-[3%] lg:ml-[23%] 2xl:mb-[6%]">
//         <Link to="/Dashboard" className="text-[#008080] hover:underline">
//           Go Back
//         </Link>

//         <div
//           className={`bg-white rounded-lg p-[3%] lg:p-[2%] lg:mb-[3vw] ${
//             rowsPerPage <= 6 ? "h-[77vh]" : "h-auto"
//           }`}
//         >
//           <div className="flex flex-col lg:flex-row justify-between lg:items-center">
//             <div className="flex">
//               <div className="flex items-center">ALL APPLICATIONS</div>
//             </div>

//             <div className="flex my-[4%] lg:my-0">
//               <div className="flex items-center">
//                 <div className="flex rounded-lg shadow-sm">
//                   <div className="flex w-10 items-center rounded-l-lg justify-center border-r border-gray-200 bg-white p-0">
//                     <GoSearch className="text-teal-600" />
//                   </div>
//                   <input
//                     type="text"
//                     className="w-full max-w-[160px] bg-white pl-2 text-base font-semibold outline-0"
//                     placeholder="Search here..."
//                     value={searchQuery}
//                     onChange={(e) => setSearchQuery(e.target.value)}
//                   />
//                 </div>
//               </div>
//               <button className="download_btn pixel_corners">
//                 <div className="button_content_download_btn">
//                   <div className="svg_container_download_btn">
//                     <svg
//                       className="download_icon_download_btn"
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="24"
//                       height="24"
//                       viewBox="0 0 24 24"
//                     >
//                       <path d="M19.479 10.092c-.212-3.951-3.473-7.092-7.479-7.092-4.005 0-7.267 3.141-7.479 7.092-2.57.463-4.521 2.706-4.521 5.408 0 3.037 2.463 5.5 5.5 5.5h13c3.037 0 5.5-2.463 5.5-5.5 0-2.702-1.951-4.945-4.521-5.408zm-7.479 6.908l-4-4h3v-4h2v4h3l-4 4z"></path>
//                     </svg>
//                   </div>
//                   <div className="text_container_download_btn">
//                     <div className="text_download_btn">Download</div>
//                   </div>
//                 </div>
//               </button>
//             </div>
//           </div>

//           <div>
//             <div className="my-[2%] overflow-x-auto">
//               <table className="w-full border-collapse text-gray-700 text-[14px] 2xl:text-[18px]">
//                 <thead className="bg-[#eeffff] text-black">
//                   <tr>
//                     {tableTitles.map((tableTitle, index) => (
//                       <th key={index} className="border-b p-2 text-left">
//                         {tableTitle}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {currentRows.map((row, index) => (
//                     <tr
//                       key={index}
//                       className={`${
//                         index % 2 === 0 ? "bg-[#F7F7F7]" : "bg-white"
//                       }`}
//                     >
//                       <td className="border-b p-2 text-left">
//                         {row.full_name}
//                       </td>
//                       <td className="border-b p-2 text-left">{row.email}</td>
//                       <td className="border-b p-2 text-left">
//                         {row.contact_number}
//                       </td>
//                       <td className="border-b p-2 text-left">{row.gender}</td>
//                       <td className="border-b p-2 text-left">
//                         {row.hospitality_experience}
//                       </td>
//                       <td className="border-b p-2 text-left">
//                         {row.available_from}
//                       </td>
//                       <td className="border-b p-2 text-center">
//                         <button
//                           onClick={() => handleEditCareerApplication(row)}
//                           className="text-[18px] rounded hover:border-l hover:border-r hover:border-sky-500"
//                         >
//                           <BsInfoLg />
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//             <Pagination
//               rowsPerPage={rowsPerPage}
//               totalRows={filteredCompany.length}
//               paginate={paginate}
//               currentPage={currentPage}
//             />
//           </div>
//         </div>
//       </div>
//       <br />
//       <WebFooter />
//     </div>
//   );
// };

// export default CareerApplications;

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { GoSearch } from "react-icons/go";
import { BsInfoLg } from "react-icons/bs";
import WebHeader from "../WebHeader/WebHeader";
import Sidebar from "../Sidebar/Sidebar";
import WebFooter from "../WebFooter/WebFooter";
import { MdKeyboardArrowRight } from "react-icons/md";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { API_URL } from "../../Config";

const CareerApplications = () => {
  const navigate = useNavigate();
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // State for managing search, pagination
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(6);

  useEffect(() => {
    const fetchCandidates = async () => {
      try {
        const response = await fetch(API_URL + "/candidates");
        if (!response.ok) {
          throw new Error("Failed to fetch candidates");
        }
        const data = await response.json();
        setCandidates(data.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchCandidates();
  }, []);

  // Filtering candidates based on search query
  const filteredCandidates = candidates.filter(
    (candidate) =>
      candidate.full_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      candidate.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
      candidate.contact_number.toString().includes(searchQuery)
  );

  // Get current rows for pagination
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredCandidates.slice(indexOfFirstRow, indexOfLastRow);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const Pagination = ({ rowsPerPage, totalRows, paginate, currentPage }) => {
    const totalPages = Math.ceil(totalRows / rowsPerPage);

    return (
      <nav className="flex justify-end my-[2%]">
        <ul className="flex items-center">
          {currentPage > 1 && (
            <li className="mx-1">
              <button
                onClick={() => paginate(currentPage - 1)}
                className="p-1 bg-gray-200 text-xs rounded-full"
              >
                <MdKeyboardArrowLeft />
              </button>
            </li>
          )}
          <li className="mx-1">
            <span className="px-2 py-2 text-xs">
              {currentPage} / {totalPages}
            </span>
          </li>
          {currentPage < totalPages && (
            <li className="mx-1">
              <button
                onClick={() => paginate(currentPage + 1)}
                className="p-1 bg-gray-200 text-xs rounded-full"
              >
                <MdKeyboardArrowRight />
              </button>
            </li>
          )}
        </ul>
      </nav>
    );
  };

  // Table column titles
  const tableTitles = [
    "Name",
    "Email",
    "Contact No.",
    "Gender",
    "Hotel Industry Experience",
    "Available From",
    "Actions",
  ];

  // Function to handle application view
  const handleViewApplication = (row) => {
    navigate("/EditCareerApplication", { state: { applicationDetails: row } });
  };

  // Format date to display only the date part
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toISOString().split("T")[0];
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        Loading...
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen text-red-500">
        Error: {error}
      </div>
    );
  }

  return (
    <div className="bg-[#F8F6F6] text-[14px] md:text-xl lg:text-[16px] 2xl:text-2xl leading-6 md:leading-8 lg:leading-7 2xl:leading-10">
      <WebHeader />

      <div className="hidden lg:block">
        <Sidebar />
      </div>
      <br />

      <div className="mt-[70px] mx-[3%] lg:ml-[23%] 2xl:mb-[6%]">
        <Link to="/Dashboard" className="text-[#008080] hover:underline">
          Go Back
        </Link>

        <div
          className={`bg-white rounded-lg p-[3%] lg:p-[2%] lg:mb-[3vw] ${
            rowsPerPage <= 6 ? "h-[77vh]" : "h-auto"
          }`}
        >
          <div className="flex flex-col lg:flex-row justify-between lg:items-center">
            <div className="flex">
              <div className="flex items-center">ALL APPLICATIONS</div>
            </div>

            <div className="flex my-[4%] lg:my-0">
              <div className="flex items-center">
                <div className="flex rounded-lg shadow-sm">
                  <div className="flex w-10 items-center rounded-l-lg justify-center border-r border-gray-200 bg-white p-0">
                    <GoSearch className="text-teal-600" />
                  </div>
                  <input
                    type="text"
                    className="w-full max-w-[160px] bg-white pl-2 text-base font-semibold outline-0"
                    placeholder="Search here..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
              </div>
              <button className="download_btn pixel_corners">
                <div className="button_content_download_btn">
                  <div className="svg_container_download_btn">
                    <svg
                      className="download_icon_download_btn"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path d="M19.479 10.092c-.212-3.951-3.473-7.092-7.479-7.092-4.005 0-7.267 3.141-7.479 7.092-2.57.463-4.521 2.706-4.521 5.408 0 3.037 2.463 5.5 5.5 5.5h13c3.037 0 5.5-2.463 5.5-5.5 0-2.702-1.951-4.945-4.521-5.408zm-7.479 6.908l-4-4h3v-4h2v4h3l-4 4z"></path>
                    </svg>
                  </div>
                  <div className="text_container_download_btn">
                    <div className="text_download_btn">Download</div>
                  </div>
                </div>
              </button>
            </div>
          </div>

          <div>
            <div className="my-[2%] overflow-x-auto">
              <table className="w-full border-collapse text-gray-700 text-[14px] 2xl:text-[18px]">
                <thead className="bg-[#eeffff] text-black">
                  <tr>
                    {tableTitles.map((tableTitle, index) => (
                      <th key={index} className="border-b p-2 text-left">
                        {tableTitle}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {currentRows.length > 0 ? (
                    currentRows.map((candidate, index) => (
                      <tr
                        key={index}
                        className={`${
                          index % 2 === 0 ? "bg-[#F7F7F7]" : "bg-white"
                        }`}
                      >
                        <td className="border-b p-2 text-left">
                          {candidate.full_name}
                        </td>
                        <td className="border-b p-2 text-left">
                          {candidate.email}
                        </td>
                        <td className="border-b p-2 text-left">
                          {candidate.contact_number || "N/A"}
                        </td>
                        <td className="border-b p-2 text-left">
                          {candidate.gender}
                        </td>
                        <td className="border-b p-2 text-left">
                          {candidate.hospitality_experience}
                        </td>
                        <td className="border-b p-2 text-left">
                          {formatDate(candidate.available_from)}
                        </td>
                        <td className="border-b p-2 text-center">
                          <button
                            onClick={() => handleViewApplication(candidate)}
                            className="text-[18px] rounded hover:border-l hover:border-r hover:border-sky-500"
                          >
                            <BsInfoLg />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={tableTitles.length}
                        className="text-center py-4"
                      >
                        No candidates found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <Pagination
              rowsPerPage={rowsPerPage}
              totalRows={filteredCandidates.length}
              paginate={paginate}
              currentPage={currentPage}
            />
          </div>
        </div>
      </div>
      <br />
      <WebFooter />
    </div>
  );
};

export default CareerApplications;
